import { restClient } from '../client';

export type AppointmentAssessment = {
  submissionId: string;
  formId: string;
  formTitle: string;
  score: number;
  scoreDiffPercentage: number | null;
  completedAt: string;
  requiresAttention?: boolean;
};

export type AppointmentIntakeAssessment = {
  createdAt: string;
  submissionId: string;
  highRisk: boolean;
};

type AppointmentAssessmentsInput = {
  appointment_id: string;
};

export type AppointmentAssesmentsOutput = {
  assessments: AppointmentAssessment[];
};

export type AppointmentIntakeAssessmentOutput = {
  intake_form?: AppointmentIntakeAssessment | null;
};

export const getAppointmentAssessments = restClient.createRequest<AppointmentAssessmentsInput, AppointmentAssesmentsOutput>({
  url: '/api/v1/form/appointment_assessments',
  method: 'GET'
});

export const getAppointmentIntakeAssessment = restClient.createRequest<AppointmentAssessmentsInput, AppointmentIntakeAssessmentOutput>({
  url: '/api/v1/form/appointment_intake',
  method: 'GET'
});

export type AppointmentAssessmentsBySubmissionIdsInput = {
  submission_ids: string[];
};

export type AppointmentAssessmentsBySubmissionIdsOutput = {
  data: AppointmentAssessment[];
};

export const getAppointmentAssessmentsBySubmissionIds = (input: AppointmentAssessmentsBySubmissionIdsInput) => {
  return restClient.request<AppointmentAssessmentsBySubmissionIdsOutput>('/api/v1/form/assessments_by_submissions', { data: input, method: 'POST' });
};
